const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/practice${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.detail || 'Unable to save practice work');
  return payload;
};

export const startPracticeAttempt = (details) => request('/attempts', {
  method: 'POST',
  body: JSON.stringify(details)
});

export const savePracticeAttempt = (attemptId, responses, status = 'in_progress') => request(`/attempts/${attemptId}`, {
  method: 'PUT',
  body: JSON.stringify({ responses, status })
});

export const loadPracticeSummary = (sourceType, sourceKey) => {
  const params = new URLSearchParams({ source_type: sourceType, source_key: sourceKey });
  return request(`/attempts/summary?${params.toString()}`);
};

export const gradePracticeAttempt = (attemptId) => request(`/attempts/${attemptId}/grade`, {
  method: 'POST'
});
